import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LanguageService } from '../services/language.service';

@Pipe({ name: 'localizedDateTime', pure: false })
export class LocalizedDateTimePipe implements PipeTransform {
  constructor(private languageService: LanguageService) { }

  transform(value: any): any {
    const locale = this.languageService.getCurrentLanguage();

    const datePipe = new DatePipe(locale);
    const format = this.getDateTimeFormat(locale);
    const dateString = datePipe.transform(value, format);

    return dateString ? dateString.replace(/ /g, '\u00A0') : dateString;
  }

  private getDateTimeFormat(locale: string | null | undefined): string {
    switch ((locale || '').toLowerCase()) {
      case 'hu':
      case 'hu-hu':
        return 'yyyy.MM.dd. HH:mm:ss';
      default:
        return 'dd.MM.yy HH:mm:ss';
    }
  }
}